<div *ngIf="orientation === 'horizontal'" class="content-height">
    <div class="row h-100">

        <div class="col-6 image-section position-relative">
            <div *ngIf="step === 'firstStep'" class="mt-4">
                <div class="d-flex justify-content-between flex-column align-items-center">
                    <apnst-material-stepper class="mb-6" [steps]="steps"></apnst-material-stepper>
                    <img class="img img-fluid" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718022865386Personal%203d%201.png" alt="">
                </div>
                <div class="container-personal">
                    <div class="row align-items-center mx-2 bg-light border-primary-faint mb-3">
                        <div class="col-1 faq-primary-div-height mt-n3">
                            <h6 class="rotate-text text-center mt-5 py-2">FAQ</h6>
                        </div>
                        <div class="col-11 d-flex justify-content-between align-items-center">
                            <div>
                                <img class="img img-fluid me-4" width="40" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718082698806Notification%201.png" alt="">
                            </div>
                            <div class="w-100 mt-1">
                                <h6 class="fs-md-6">Why we need your PAN Card?</h6>
                                <p class="fs-8">Banks, NBFCs, and international lenders use your PAN card to verify your credit history, ensuring a secure and efficient lending process.</p>
                            </div>
                        </div>

                    </div>
                    <span class="border-dashed d-flex mx-3 mb-3"></span>
                    <div class="row align-items-center mx-2 bg-light border-warning-faint">

                        <div class="col-1 faq-warning-div-height mt-n0">
                            <h6 class="rotate-text text-center mt-4 py-3">NOTE</h6>
                        </div>
                        <div class="col-11 d-flex justify-content-between align-items-center">
                            <div>
                                <img class="img img-fluid me-4" width="40" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718086250706Notification%201%20%281%29.png" alt="">
                            </div>
                            <div class="w-100 mt-3">
                                <p>Please Enter your accurate contact details for lenders to connect faster.</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


            <div *ngIf="step === 'secondStep'" class="mt-4">
                <div class="d-flex justify-content-between flex-column align-items-center">
                    <apnst-material-stepper class="mb-6" [steps]="steps"></apnst-material-stepper>
                    <img class="img img-fluid mb-6" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718098055909Frame%201000002351.png" alt="">
                </div>
                <div class="container-personal">
                    <div class="row align-items-center mx-2 bg-light border-primary-faint mb-3">
                        <div class="col-1 faq-primary-div-height mt-n3">
                            <h6 class="rotate-text text-center mt-5 py-2">FAQ</h6>
                        </div>
                        <div class="col-11 d-flex justify-content-between align-items-center">
                            <div>
                                <img class="img img-fluid me-4" width="40" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718082698806Notification%201.png" alt="">
                            </div>
                            <div class="w-100 mt-3">
                                <h5>Why do we need your work experience history?</h5>
                                <p class="">Having a work experience positively impacts your Loan approval chances and can increase the loan amount.</p>
                            </div>
                        </div>
                    </div>
                    <span class="border-dashed d-flex mx-3 mb-3"></span>
                    <div class="row align-items-center mx-2 bg-light border-warning-faint">
                        <div class="col-1 faq-warning-div-height mt-n0">
                            <h6 class="rotate-text text-center mt-4 py-3">NOTE</h6>
                        </div>
                        <div class="col-11 d-flex justify-content-between align-items-center">
                            <div>
                                <img class="img img-fluid me-4" width="40" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1718086250706Notification%201%20%281%29.png" alt="">
                            </div>
                            <div class="w-100 mt-3">
                                <p>In case of Working Professional, please enter your net in hand monthly salary after deduction of taxes (TDS, PF, PT, ESI).</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <div class="col-6">
            <div class="container h-100">
                <div class="">
                    <apnst-common-header [configHeader]="configPersonalDetailsHeader" [showHeaderWeb]="true" (headerStepEmitted)="emitStep($event)"></apnst-common-header>

                    <div *ngIf="step === 'firstStep'" class="">
                        <p class="text-muted">Personal Details are mandatory to share your application with the education loan providers.
                        </p>
                    </div>

                    <div class="">
                        <aerp-base-schema-form [model]="model" [dataProcessor]="dataProcessor.bind(this)" [dataModel]="dataModel" (onSubmit)="onSubmit($event)" [layout]="layout">
                        </aerp-base-schema-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="mt-5" *ngIf="orientation === 'vertical'">
    <apnst-material-stepper [steps]="steps"></apnst-material-stepper>
    <div class="container">
        <div class="">
            <apnst-common-header [configHeader]="configPersonalDetailsHeader" (headerStepEmitted)="emitStep($event)"></apnst-common-header>
        </div>
        <div *ngIf="step === 'firstStep'" class="mx-3">
            <p class="text-muted">Personal Details are mandatory to share your application with the education loan providers.
            </p>
        </div>

        <div class="px-3">
            <aerp-base-schema-form [model]="model" [dataModel]="dataModel" (onSubmit)="onSubmit($event)" [dataProcessor]="dataProcessor.bind(this)" [layout]="layoutForMobileView">
            </aerp-base-schema-form>
        </div>
    </div>
</div>